import ApiClient from ".."

// In DTOs
import type AuthPostMagicLinkIn from "../../dtos/in/AuthPostMagicLinkIn"

// Out DTOs
import AuthGetCheckSessionOut from "../../dtos/out/AuthGetCheckSessionOut"
import GenericOut from "../../dtos/out/GenericOut"

export class AuthEndpoints {
  constructor(private client: ApiClient) {}
  static readonly BASE_URL = "/auth"

  /**
   * Checks for an active session.
   */
  async getCheckSession() {
    return this.client.get<AuthGetCheckSessionOut>(AuthEndpoints.BASE_URL, "/check-session")
  }

  /**
   * Redirect to google oauth2 consent screen.
   */
  async goToGoogleOauth(redirectPath: string, failurePath?: string) {
    const protocol = location.protocol
    const host = location.host
    const redirectUrl = encodeURIComponent(`${protocol}//${host}${redirectPath}`)
    const failureUrl = failurePath ? encodeURIComponent(`${protocol}//${host}${failurePath}`) : redirectUrl
    const endpoint = `${AuthEndpoints.BASE_URL}/google`
    window.location.href = this.client.baseUrl + endpoint + `?redirectUrl=${redirectUrl}&failureUrl=${failureUrl}`
  }

  /**
   * Logs out the user by removing the session cookie (legacy - clears all cookies).
   */
  async postLogout() {
    return this.client.post<GenericOut>(AuthEndpoints.BASE_URL, "/logout", null)
  }

  /**
   * Logs out the user from app frontend only (clears sid_app cookie).
   */
  async postLogoutApp() {
    return this.client.post<GenericOut>(AuthEndpoints.BASE_URL, "/logout/app", null)
  }

  /**
   * Logs out the user from dashboard frontend only (clears sid_coach cookie).
   */
  async postLogoutDashboard() {
    return this.client.post<GenericOut>(AuthEndpoints.BASE_URL, "/logout/dashboard", null)
  }

  /**
   * Sends a magic link to the user's email.
   */
  async postMagicLink(payload: AuthPostMagicLinkIn) {
    return this.client.post<GenericOut>(AuthEndpoints.BASE_URL, "/magic/email", payload)
  }

  /**
   * Exchanges authKey for a session cookie, to authenticate the user.
   */
  async postMagicLogin(authKey: string) {
    const headers = {
      Authorization: `Bearer ${authKey}`
    }
    return this.client.post<GenericOut>(AuthEndpoints.BASE_URL, "/magic", null, headers)
  }
}
